import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { CartProvider } from "./context/CartContext";
import { CompareProvider } from "./context/CompareContext";
import { LayoutProvider } from "./context/LayoutContext";
import { ThemeProvider } from "./context/ThemeContext";
import { LanguageProvider } from "./context/LanguageContext";
import { SearchProvider } from "./context/SearchContext";
import CartDrawer from "./components/feature/CartDrawer";
import CompareBar from "./components/feature/CompareBar";
import PromoBar from "./components/feature/PromoBar";
import WhatsAppPopup from "./components/feature/WhatsAppPopup";
import FloatingWhatsApp from "./components/feature/FloatingWhatsApp";
import GamingMascot from "./pages/home/components/GamingMascot";
import ScrollToTop from "./components/feature/ScrollToTop";
import LoadingScreen from "./components/feature/LoadingScreen";
import GlobalSearch from "./components/feature/GlobalSearch";
import { useState } from "react";

function App() {
  const [showLoader, setShowLoader] = useState(() => {
    if (typeof sessionStorage !== 'undefined') {
      const seen = sessionStorage.getItem('spartech_loaded');
      if (seen) return false;
    }
    return true;
  });

  const handleLoaderComplete = () => {
    sessionStorage.setItem('spartech_loaded', '1');
    setShowLoader(false);
  };

  return (
    <I18nextProvider i18n={i18n}>
      <ThemeProvider>
        <LanguageProvider>
          <LayoutProvider>
            <CompareProvider>
              <CartProvider>
                <SearchProvider>
                  {showLoader && <LoadingScreen onComplete={handleLoaderComplete} />}
                  <BrowserRouter basename={__BASE_PATH__}>
                    <GlobalSearch />
                    <PromoBar />
                    <AppRoutes />
                    <CartDrawer />
                    <CompareBar />
                    <WhatsAppPopup />
                    <FloatingWhatsApp />
                    <GamingMascot />
                    <ScrollToTop />
                  </BrowserRouter>
                </SearchProvider>
              </CartProvider>
            </CompareProvider>
          </LayoutProvider>
        </LanguageProvider>
      </ThemeProvider>
    </I18nextProvider>
  );
}

export default App;